import Grid from '@material-ui/core/Grid';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import React, { Dispatch, PureComponent } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { Action } from 'redux';
import { Assets } from './components/Assets';
import { ConfirmDialog } from './components/ConfirmDialog';
import { Content } from './components/Content';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { breakpointMobile } from './components/lab/breakpoints';
import { spacings } from './components/lab/spacings';
import { requestItinerary } from './store/reducers/itinerary/actions';

interface DispatchProps {
  requestItinerary(): void;
}

interface AppProps extends DispatchProps, WithStyles<typeof styles> {}

class AppBase extends PureComponent<AppProps> {
  public componentDidMount() {
    this.props.requestItinerary();
  }
  public render() {
    const { classes } = this.props;

    return (
      <>
        <Grid
          container
          direction="column"
          alignItems="center"
          className={classes.app}
        >
          <Assets />
          <Header />
          <Content />
        </Grid>
        <ConfirmDialog />
        <Footer />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  requestItinerary: () => {
    dispatch(requestItinerary());
  },
});

// styled
const styles = (theme: Theme) => {
  const {
    between: {
      card: { header: cardHeaderSpacing },
    },
  } = spacings(theme);

  return createStyles({
    app: {
      backgroundColor: theme.palette.background.default,
      boxSizing: 'border-box',
      minHeight: '100vh',
      [breakpointMobile(theme)]: {
        width: '100%',
      },
    },
    cardHeaderSpacing,
  });
};

const enhance = compose<AppProps, {}>(
  connect(undefined, mapDispatchToProps),
  withStyles(styles),
);

export const App = enhance(AppBase);

App.displayName = 'App';
